export enum ApiOperations {
  read = 'read',
  readAll = 'readAll',
  delete = 'delete',
  create = 'create',
  update = 'update',
  exportAll = 'exportAll'
}
